<template>
    <div>
        <v-card class="pa-3 mx-4 mt-3">
            <v-layout
                row
                class="px-3 pt-3 pb-2 mb-2 ma-1"
                style="border: 2px solid #43a047; border-radius: 6px;"
            >
                <v-layout column>
                    <div class="title">Auto Match</div>
                    <v-layout row class="pb-2">
                        <div class="font-weight-medium mr-1">Title:</div>
                        <div class="font-weight-regular">
                            {{ autoMatch.title }}
                        </div>
                        <div class="font-weight-medium ml-3 mr-1">Type:</div>
                        <div class="font-weight-regular">
                            {{ autoMatch.type }}
                        </div>
                    </v-layout>
                </v-layout>
            </v-layout>
        </v-card>

        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :beforeSetupGrid="beforeSetupGrid"
            :selectionEnabled="true"
            ref="grid"
            :actions="actions"
        ></dx-grid>

        <v-dialog scrollable v-model="updateDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-2"
                    >Update Person - {{ clickedRow.personID }}</v-card-title
                >

                <div class="px-2 mt-2">
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium">
                            {{
                                clickedRow.first +
                                    " " +
                                    clickedRow.last +
                                    " (" +
                                    getGander(clickedRow) +
                                    ")"
                            }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">Address</div>
                        <div>
                            {{ getAddress(clickedRow) }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            City:
                        </div>
                        <div>{{ clickedRow.city }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Zip:
                        </div>
                        <div>{{ clickedRow.zip }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            DOB:
                        </div>
                        <div>{{ clickedRow.dob | date }}</div>
                    </v-layout>
                    <v-layout
                        row
                        class="mb-2"
                        v-if="autoMatch.type == 'STUDENT'"
                    >
                        <div class="font-weight-medium width-150">
                            ANSL Name:
                        </div>
                        <div>{{ clickedRow.anslName }}</div>
                    </v-layout>
                    <v-layout
                        row
                        class="mb-2"
                        v-if="autoMatch.type == 'STUDENT'"
                    >
                        <div class="font-weight-medium width-150">
                            ANSL Address:
                        </div>
                        <div>{{ clickedRow.anslAddress }}</div>
                    </v-layout>
                    <v-divider class="my-2 pb-2"></v-divider>
                    <v-select
                        v-if="autoMatch.type == 'FAMILY'"
                        class="pt-3"
                        :items="matchTypes"
                        label="Match Type"
                        v-model="clickedRow.matchType"
                        clearable
                        ref="matchType"
                        :rules="[rules.required]"
                        @change="matchTypeChanged"
                    ></v-select>
                    <!-- <v-select
                        class="pt-3"
                        :items="statuses"
                        label="Status"
                        v-model="clickedRow.status"
                        clearable
                        ref="status"
                        :rules="[rules.required]"
                    ></v-select> -->
                </div>
                <v-card-actions class="pt-3 mr-2 mt-3 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="updateDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        dark
                        color="success"
                        @click="save"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog scrollable v-model="bulkUpdateDialog" max-width="1200">
            <update-auto-match
                :closeUpdateDialog="closeUpdateDialog"
                :selected="selected"
                :reloadGrid="reloadGrid"
                :autoMatch="autoMatch"
                :doeData="doeData"
            ></update-auto-match>
        </v-dialog>
        <v-dialog persistent v-model="votingDialog" max-width="1000">
            <voting-master-list-person
                :person="presonInfo"
                :reload="reload"
                :close="closeVotingDialog"
            ></voting-master-list-person>
        </v-dialog>

        <v-dialog persistent v-model="deleteDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Delete Auto Matches</v-card-title
                >

                <div class="font-weight-medium">
                    The
                    {{ selected.length }}
                    selected auto matches will be deleted
                </div>

                <v-card-actions class="mr-0 mt-3 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="deleteDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteMatches()"
                    >
                        delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div></template
>
<script>
import moment from "moment";
import updateAutoMatch from "./UpdateAutoMatchDetails";
import votingMasterListPerson from "./VotingMasterListPerson.vue";

export default {
    components: {
        updateAutoMatch,
        votingMasterListPerson,
    },
    data: () => ({
        title: "Auto Match Details",
        url: "",
        actions: [],
        selected: [],
        bulkUpdateDialog: false,
        updateDialog: false,
        processing: false,
        deleteDialog: false,

        clickedRow: {},
        autoMatch: {},

        user: "",
        matchTypes: ["Husband", "Wife", "Daughter", "Son", "Not Matched"],
        statuses: [],
        doeData: [],

        today: moment().format("YYYY-MM-DD HH:mm:ss"),

        votingDialog: false,
        presonInfo: {},

        rules: {
            required: (v) => {
                return !!v || "Required";
            },
        },

        columns: [
            {
                field: "status",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                icon: (value, row) => {
                    if (!value) return "";

                    switch (value) {
                        case "Not Matched":
                            return "mdi-alert-circle";
                        case "Verified":
                            return "mdi-check-circle";
                        case "Pending":
                            return "mdi-clock";
                        default:
                            return "";
                    }
                },
                iconColor: (value, row) => {
                    if (!value) return "";

                    switch (value) {
                        case "Not Matched":
                            return "#f35123";
                        case "Verified":
                            return "success";
                        case "Pending":
                            return "#fdb400";
                        default:
                            return "";
                    }
                },
            },
            {
                field: "personID",
                label: "Person ID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                template: "link-action-cell-template",
                showLink: (row) => {
                    return true;
                },
            },
            {
                label: "Doe ID",
                field: "doeID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First",
                field: "first",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last",
                field: "last",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Match Type",
                field: "matchType",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "House",
                field: "house",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Street",
                field: "street",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Apt",
                field: "apt",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "City",
                field: "city",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Zip",
                field: "zip",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Gander",
                field: "s",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "DOB",
                field: "dob",
                type: "date",
                format: "MM/dd/yyyy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Age",
                field: "age",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Ansl Address",
                field: "anslAddress",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Ansl Heb Name",
                field: "anslHebName",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Ansl Name",
                field: "anslName",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "matchedID",
                label: "Matched ID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                template: "link-action-cell-template",
                showLink: (row) => {
                    return true;
                },
            },
            {
                label: "Matched",
                field: "matched",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
        ],

        studentColumns: [
            {
                field: "status",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                icon: (value, row) => {
                    if (!value) return "";

                    switch (value) {
                        case "Verified":
                            return "mdi-check-circle";
                        case "Pending":
                            return "mdi-clock";
                        default:
                            return "";
                    }
                },
                iconColor: (value, row) => {
                    if (!value) return "";

                    switch (value) {
                        case "Verified":
                            return "success";
                        case "Pending":
                            return "#fdb400";
                        default:
                            return "";
                    }
                },
            },
            {
                field: "personID",
                label: "Person ID",
                //link: "DinnerAccountView",
                format: "",
                //template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "doeID",
                label: "DOE ID",
                //link: "DinnerAccountView",
                format: "",
                //template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student ID",
                field: "studentID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First",
                field: "first",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last",
                field: "last",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Hebrew",
                field: "firstH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Hebrew",
                field: "lastH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Source",
                field: "source",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            // {
            //     label: "Match Type",
            //     field: "matchType",
            //     visible: true,
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            {
                label: "Address 1",
                field: "address1",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Apt",
                field: "apt",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "City",
                field: "city",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "State",
                field: "state",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Zip",
                field: "zip",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Gander",
                field: "gander",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "DOB",
                field: "dob",
                type: "date",
                format: "MM/dd/yyyy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Ansl Address",
                field: "anslAddress",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Ansl Heb Name",
                field: "anslHebName",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Ansl Name",
                field: "anslName",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {
        this.user = this.$store.state.authentication.user;

        this.columns.find((c) => c.field == "personID").linkAction = (row) => {
            this.openVotingDialog(row.personID);
        };

        this.columns.find((c) => c.field == "matchedID").linkAction = (row) => {
            this.openVotingDialog(row.matchedID);
        };
    },
    mounted() {},
    methods: {
        async beforeSetupGrid() {
            const autoMatch = await this.$http.get(
                "api/votingRegistrationAutoMatch/getByID?id=" +
                    this.$route.params.id,
            );

            this.autoMatch = autoMatch;

            this.actions.push({
                text: "Delete",
                action: this.openDeleteDialog,
                showOnSelection: true,
            });

            this.actions.push({
                text: "Update Status",
                action: this.openUpdateStatusDialog,
                showOnSelection: true,
            });

            if (["STUDENT", "STUDENT TO DOE"].includes(autoMatch.type)) {
                this.columns = this.studentColumns;
            }

            this.url =
                autoMatch.type == "FAMILY"
                    ? "VotingRegistrationAutoMatchDetails?autoMatchID=" +
                      this.$route.params.id
                    : "studentAutoMatchDetails?autoMatchID=" +
                      this.$route.params.id;
        },
        async openVotingDialog(personID) {
            if (!personID) {
                return this.$notify({
                    group: "notification",
                    text: "No Person ID",
                    type: "warning",
                });
            }

            this.presonInfo = await this.$http.get(
                "api/applicantStudents/getPersonByID?personID=" + personID,
            );

            this.votingDialog = true;
        },
        closeVotingDialog() {
            this.votingDialog = false;
        },
        reload() {
            this.$refs.grid.reloadGrid();
        },
        openDeleteDialog() {
            const selected = JSON.parse(
                JSON.stringify(this.$refs.grid.getSelectedRowsData()),
            );

            this.selected = selected;

            this.deleteDialog = true;
        },
        async openUpdateStatusDialog() {
            const selected = JSON.parse(
                JSON.stringify(this.$refs.grid.getSelectedRowsData()),
            );

            this.selected = selected.filter((s) => s.status == "Pending");

            if (this.autoMatch.type != "STUDENT TO DOE") {
                this.bulkUpdateDialog = true;
                return;
            }

            const response = await this.$http.post(
                "api/votingRegistrationAutoMatch/getDoeByIds",
                this.selected.map((s) => s.doeID),
            );

            this.doeData = response;

            this.bulkUpdateDialog = true;
        },
        onRowClicked(row) {
            this.clickedRow = JSON.parse(JSON.stringify(row));

            this.statuses =
                row.status == "Pending"
                    ? ["Pending", "Verified", "Not Matched"]
                    : ["Verified", "Not Matched"];

            this.matchTypes =
                row.status == "Pending"
                    ? ["Husband", "Wife", "Daughter", "Son", "Not Matched"]
                    : [row.matchType, "Not Matched"];

            this.updateDialog = true;
        },
        closeUpdateDialog() {
            this.bulkUpdateDialog = false;
        },
        reloadGrid() {
            this.$refs.grid.reloadGrid();
        },
        matchTypeChanged(value) {
            if (!value) {
                this.clickedRow.status = "Pending";

                return;
            }

            if (value == "Not Matched") {
                this.clickedRow.status = value;
            } else {
                this.clickedRow.status = "Verified";
            }
        },
        getGander(person) {
            if (this.autoMatch.type == "STUDENT") {
                return person.gander;
            }

            return person.s == "M"
                ? "Male"
                : person.s == "F"
                ? "Female"
                : "Undefined";
        },
        getAddress(person) {
            if (this.autoMatch.type == "STUDENT") {
                return person.address1;
            }

            return person.house + " " + person.street + " " + person.apt;
        },
        validate() {
            if (this.autoMatch.type == "STUDENT") return true;

            return this.$refs.matchType.validate(true);
        },
        async save() {
            if (!this.validate()) return;

            this.processing = true;

            try {
                await this.$http.post("api/voting/UpdateMatchStatus", {
                    user: this.$store.state.authentication.user,
                    matches: [
                        {
                            status: this.clickedRow.status,
                            matchType: this.clickedRow.matchType,
                            personID: this.clickedRow.personID,
                            id: this.clickedRow.id,
                            doeID: this.clickedRow.doeID,
                            studentID: this.clickedRow.studentID,
                        },
                    ],
                });

                this.processing = false;

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.updateDialog = false;
                this.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async deleteMatches() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/votingRegistrationAutoMatch/removeAutoMatches",
                    this.selected.map((s) => s.id),
                );

                this.processing = false;

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.deleteDialog = false;
                this.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
